import styled from "styled-components"
import { device } from "breakpoints"
import { MainColumn } from "../MainColumn"
import { getGradient } from "helpers/getGradient"
import { getSolidColor } from "helpers/getSolidColor"

export const SearchFiltersContainer = styled(MainColumn)`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0 15px 25px 0 rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  margin-top: -30px;
  z-index: 1;
  position: relative;
  margin-bottom: 30px;

  @media ${device.desktop} {
    flex-direction: row;
    max-width: 1160px;
    margin-top: -40px;
    margin-bottom: 70px;
  }

  @media ${device.large} {
    margin-top: -50px;
  }
`
export const TriggerItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0 20px;
  border: none;
  height: 60px;

  @media ${device.desktop} {
    margin-left: auto;
    border-bottom: none;
    height: 80px;
    padding: 0 20px;
    cursor: inherit;
  }

  @media ${device.large} {
    padding: 0 30px;
    height: 100px;
  }

  svg {
    height: 12px;
    width: 8px;
    /* transition: 150ms; */
    transform: ${props =>
      props.filtersShown
        ? "rotate(90deg) scale(-1)"
        : "rotate(90deg) scale(1)"};
    justify-self: flex-end;
    display: block;

    @media ${device.desktop} {
      display: none;
    }
    path {
      fill: #4c4d58;
    }
  }
`

export const Label = styled.div`
  flex-grow: 1;
  position: relative;
  display: flex;
  align-items: center;

  @media ${device.desktop} {
    display: none;
  }
  h4 {
    font-size: 16px;
    text-transform: uppercase;
    flex-shrink: 0;

    @media ${device.desktop} {
      font-size: 17px;
    }

    @media ${device.large} {
      font-size: 20px;
    }
  }
`

export const FilterCount = styled.span`
  height: 26px;
  width: auto;
  padding: 0 8px;
  min-width: 26px;
  background-image: ${props => getGradient(props.site)};
  border-radius: 24px;
  color: white;
  font-family: "Roboto", Arial, sans-serif;
  font-weight: 500;
  font-size: 14px;
  margin-left: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;

  @media ${device.large} {
    padding: 0 11px;
    height: 30px;
    min-width: 30px;
  }

  span {
    @media ${device.desktop} {
      transform: translateY(-1px);
    }
  }
`

export const ResultsCount = styled.p`
  font-size: 14px;
  margin-right: 20px;
  padding-left: 23px;
  height: 100%;
  display: flex;
  align-items: center;
  border-left: 1px solid rgba(210, 212, 224, 0.7);

  @media ${device.desktop} {
    font-size: 16px;
    margin: 0;
    padding: 0;
    margin-left: auto;
    border: none;
  }
  span {
    font-weight: 600;
    color: black;
    margin-right: 4px;
  }
`

export const Filters = styled.ul`
  display: ${props => (props.filtersShown ? "flex" : "none")};
  flex-direction: column;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  transform: translateY(100%);
  box-shadow: 0 15px 25px 0 rgba(0, 0, 0, 0.1);
  border-radius: inherit;
  background: #ffffff;
  border-top: 1px solid rgba(210, 212, 224, 0.7);
  @media (min-width: 480px) {
    max-width: 315px;
  }
  @media ${device.desktop} {
    max-width: 100%;
    flex-direction: row;
    box-shadow: none;
    width: auto;
    position: static;
    transform: none;
    border: none;
    display: flex;
    order: -1;
  }
`

export const CheckBox = styled.span`
  background: #ffffff;
  border: 1px solid
    ${props => (props.selected ? getSolidColor(props.site) : "#d2d4e0")};
  box-shadow: 0 1px 0 0
    ${props => (props.selected ? getSolidColor(props.site) : "#d2d4e0")};
  border-radius: 4px;
  width: 30px;
  transition: 100ms;
  height: 30px;
  margin-right: 15px;
  position: relative;
  @media ${device.large} {
    margin-right: 20px;
  }

  ::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    opacity: ${props => (props.selected ? 1 : 0)};
    transition: 100ms;
    width: 9px;
    height: 15px;
    z-index: 3;
    border: solid ${props => getSolidColor(props.site)};
    border-width: 0 3px 3px 0;
    transform: ${props =>
      props.selected
        ? "translate3d(-50%, -60%, 0) scale(1) rotate(45deg)"
        : "translate3d(-50%, -40%, 0) scale(0.3) rotate(45deg)"};
  }
`

export const FilterItem = styled(TriggerItem)`
  border-bottom: 3px solid rgba(210, 212, 224, 0.5);
  background: ${props => props.selected && "#F6F8FA"};
  transition: 100ms;
  position: relative;
  @media ${device.desktop} {
    width: auto;
    border-right: 1px solid rgba(210, 212, 224, 1);
    cursor: pointer;
  }
  ${FilterCount} {
    margin-left: auto;

    @media ${device.desktop} {
      margin-left: 15px;
    }
  }

  ${Label} {
    @media ${device.desktop} {
      display: flex;
    }
  }
  :last-child {
    border-bottom: none;
  }

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    ::-ms-check{
      display:none
    }

`
